import { useState } from "react";
import { useNavigate } from "react-router-dom";
import ContentLayout from "../../components/UI/Layout/ContentLayout.tsx";
import ProfileList from "../../components/Profile/ProfileList";
import ProfileBailleurCreateWizard from "../../components/Profile/ProfileBailleurCreateWizard";
import { datadogRum } from "@datadog/browser-rum";
// @ts-expect-error pure js
import { RumActions } from "../../utils/constants/rum_actions.js";
import HeaderLayout from "../../components/UI/Layout/HeaderLayout.tsx";
import type { ProfileBailleur } from "../../components/Profile/types";

export default function ProfileBailleurListPage() {
  const nav = useNavigate();
  const [isCreateWizardOpen, setIsCreateWizardOpen] = useState(false);

  function addProfileHandler() {
    setIsCreateWizardOpen(true);
    datadogRum.addAction(RumActions.PROFILE_BAILLEUR_STARTED);
  }

  function submitHandler(created?: ProfileBailleur) {
    setIsCreateWizardOpen(false);
    datadogRum.addAction(RumActions.PROFILE_BAILLEUR_COMPLETED);
    // Enchaînement onboarding : arrivée sur la fiche du profil créé, où le
    // guide de première visite se déclenche.
    if (created?.id) {
      nav(`/bailleur/profiles/${created.id}`);
    }
  }

  return (
    <>
      <ProfileBailleurCreateWizard
        open={isCreateWizardOpen}
        onOpenChange={(open) => {
          setIsCreateWizardOpen(open);
          if (!open) {
            datadogRum.addAction(RumActions.PROFILE_BAILLEUR_CANCELLED);
          }
        }}
        onSubmit={submitHandler}
      />

      <ContentLayout
        header={
          <HeaderLayout
            title={"Bailleurs"}
            breadcrumb={[
              { label: "Tableau de bord", to: "/bailleur" },
              { label: "Bailleurs" },
            ]}
          />
        }
        body={
          <div className="content">
            <ProfileList onAddProfile={addProfileHandler} />
          </div>
        }
      />
    </>
  );
}
